import { render } from "./SpeakerCodes.vue?vue&type=template&id=2a80fd93&scoped=true"
import script from "./SpeakerCodes.vue?vue&type=script&lang=js"
export * from "./SpeakerCodes.vue?vue&type=script&lang=js"

import "./SpeakerCodes.vue?vue&type=style&index=0&id=2a80fd93&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a80fd93"]])

export default __exports__